import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

const wrapRootElement = ({ element }) => {
  return (
    <ParallaxProvider>
      {element}
    </ParallaxProvider>
  )
}

export { 
  wrapRootElement
}